import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { DealStatusEnums } from '../../common/Enums';
import { FlexDiv, WideBox } from '../../styles/styles';
import { filterPreference } from '../../util/UtilFunctions';
import DealForm from '../DealForm';

const EditDeal = () => {
  const { authStore, dataStore, dealMapperStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [deal, setDeal] = useState(null);
  const history = useHistory();
  const { dealID } = useParams();
  const { accountInfo } = authStore;
  const { NotificationPref } = accountInfo;

  const getDeal = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/deal/${dealID}`,
      );
      setDeal(data);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getDeal();
    authStore.retrieveUser();
  }, []);
  if (isLoading) return <Spinner />;
  return (
    <FlexDiv style={{ marginBottom: '1rem', marginTop: '1rem' }}>
      <WideBox style={{ justifyContent: 'center', maxWidth: '500px' }}>
        <DealForm
          deal={deal}
          buttons={[
            <Button
              color="secondary"
              variant="outlined"
              size="large"
              style={{
                margin: '5px',
              }}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>,
          ]}
          onSubmit={async values => {
            const {
              DealId,
              DealNumber,
              Title,
              Description,
              ContractDate,
              TransactionDate,
              BillableDate,
              PayableDate,
              AgentContactId,
              AgentContact,
              ApprovedBy,
              StatusId,
            } = values;
            try {
              const nPref = filterPreference(NotificationPref, 'Deal Status');

              await authStore.request.post(
                `${process.env.REACT_APP_API}/api/deal`,
                {
                  DealId,
                  DealNumber,
                  Title,
                  Description,
                  ContractDate,
                  TransactionDate,
                  BillableDate,
                  PayableDate,
                  AgentContactId,
                  ApprovedBy,
                  StatusId,
                  AgentContact,
                  NotificationPref: nPref,
                  Email: {
                    address: accountInfo.Email,
                    name: accountInfo.Name.split(' ')[0],
                    status: DealStatusEnums[StatusId],
                  },
                },
              );
              await Promise.all([
                dealMapperStore.reset(),
                dataStore.retrieveDeals(),
              ]);
              history.push(`/deal/${dealID}`);
            } catch (e) {
              console.error(e);
            }
          }}
        />
      </WideBox>
    </FlexDiv>
  );
};

export default EditDeal;
